import React, { useState } from "react";

/** 🎯 Tooltip (Title Component) */
export const Title = ({ text }) => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "120%",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#fff",
        color: "#000",
        padding: "8px 12px",
        borderRadius: "6px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        whiteSpace: "nowrap",
        zIndex: 1000,
        fontSize: 15,
      }}
    >
      {text}
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "6px solid #fff",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      />
    </div>
  );
};

/** 🎯 Modal Component */
export const Modal = ({ isOpen, onClose, children, width }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal Window */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          zIndex: 1001,
          width: width
        }}
      >
        <button
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            padding: 0,
            border: "none",
            background: "none",
            fontSize: "16px",
            cursor: "pointer",
            color: 'black'
          }}
          onClick={onClose}
        >
          ✖
        </button>
        {children}
      </div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        }}
        onClick={onClose}
      />
    </>
  );
};
